import { useContext } from "react"
import { MessagesContext, StreamingContext } from "../context/messages-context"

export function useMessagesContext() {
  return useContext(MessagesContext)
}

export function useStreamingContext() {
  return useContext(StreamingContext)
}
